import React from 'react';

function CrossCloseButton({ onClick }) {
  return (
    <div className="cross-close" onClick={onClick}>X</div>
  );
}

CrossCloseButton.propTypes = {};

export default CrossCloseButton;
